import styles from "./SkipLinks.module.css";
export default function SkipLinks() {
	return (
		<nav role="navigation" className={styles.skipLinks}>
			<a href="#main-content" className={styles.skipLink}>
				Skip to main content
			</a>
			<a href="#navigation" className={styles.skipLink}>
				Skip to navigation
			</a>
		</nav>
	);
}